module.exports = __webpack_public_path__ + "f0290edb0aacc01bb5eaf3880d5ac3ad.png";